import script from "./StoreAdminAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminAnnouncementDetail.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminAnnouncementDetail.vue?vue&type=style&index=0&id=66e8f69b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e8f69b"]])

export default __exports__